import { render, staticRenderFns } from "./inform-list.vue?vue&type=template&id=22d2ab7a&scoped=true"
import script from "./inform-list.vue?vue&type=script&lang=js"
export * from "./inform-list.vue?vue&type=script&lang=js"
import style0 from "./inform-list.vue?vue&type=style&index=0&id=22d2ab7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2f37ed56e32c39bf37bd07aa5cbb5c73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d2ab7a",
  null
  
)

export default component.exports